export let environment: {
    apiUrl: string;
    production: boolean;
    apiUrl1: string;
    webSocketNotificationUrl: string;
    webSocketChatUrl: string;
    webSocketApiUrl: string;
};
environment = {
    production: false,
    apiUrl: "http://localhost/nt-pms/api/public",
    // apiUrl1: 'http://localhost:9090'
    apiUrl1: "https://isys-dev.fixura.in",
    webSocketNotificationUrl: "http://localhost:8080/notifications",
    webSocketChatUrl: "http://localhost:8080/chat",
    webSocketApiUrl: "http://localhost:8080",
};
